// reducers/InventoryReport.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    products: [],
    chartData: [],
    summary: {
      totalAmount: 0,
      totalCount: 0
    },
    formatFlags: {
      showSubcategoryFormat: false,
      showCategoryFormat: false,
      showBatchNumberFormat: false,
      showMfgDateFormat: false,
      showExpDateFormat: false,
      showBrandNameFormat: false
    },
    searchSections: []
  },
  loading: false,
  error: null,
};

const inventoryReportSlice = createSlice({
  name: "CustomeinventoryReport",
  initialState,
  reducers: {
    inventoryReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    inventoryReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    inventoryReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetInventoryReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    }
  },
});

export const {
  inventoryReportRequest,
  inventoryReportSuccess,
  inventoryReportFailure,
  resetInventoryReport,
} = inventoryReportSlice.actions;

export default inventoryReportSlice.reducer;